const rowMenu = 'rowMenu';
const rowNumber = 'rowNumber';
const rowDecorators = 'rowDecorators';

export default { rowMenu, rowNumber, rowDecorators };
